import React from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { ConfigFieldControl, ConfigTextField } from '@sierralabs/core-ui';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { ComponentRenderer } from '../renderers';
import { SiteComponent } from '../SiteComponentPlugin';
import { SiteComponentStackConfigurator } from './SiteComponentStackPlugin';
export const SiteGridItem = props => {
    var _a;
    const component = useSubscribeComponentChanges(SiteGridItemPlugin, props);
    const { xs, sm, md, lg } = (component === null || component === void 0 ? void 0 : component.props) || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-grid-item'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteGridItemPlugin }, props),
        React.createElement(Grid, Object.assign({ item: true, className: classes.join(' '), xs: xs, sm: sm, md: md, lg: lg }, hoverProps(component)), (_a = component.children) === null || _a === void 0 ? void 0 : _a.map(child => (React.createElement(ComponentRenderer, { key: child.id, component: child }))))));
};
export const SiteGridItemConfigurator = props => {
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(React.Fragment, null,
        ['xs', 'sm', 'md', 'lg'].map(size => {
            var _a;
            return (React.createElement(ConfigFieldControl, { key: size },
                React.createElement(ConfigTextField, { fullWidth: true, type: 'number', label: size.toUpperCase(), value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a[size]) || '', onChange: event => {
                        const value = event.target.value;
                        update(`props.${size}`, value === 'auto' ? 'auto' : parseInt(value));
                    } }, ['auto', 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(spacing => (React.createElement(MenuItem, { key: spacing, value: spacing }, spacing))))));
        }),
        React.createElement(SiteComponentStackConfigurator, { component: props.component })));
};
export const SiteGridItemPlugin = {
    name: 'Grid Item',
    type: 'grid-item',
    component: SiteGridItem,
    configurator: SiteGridItemConfigurator
};
//# sourceMappingURL=SiteGridItemPlugin.js.map